<div class="flex-row">
  <mat-card>

    <mat-card-title>Contact</mat-card-title>

    <mat-card-content>
      <!-- Content
      <div class="mat-display-4">Display 4</div>
      <div class="mat-display-3">Display 3</div>
      <div class="mat-display-2">Display 2</div>
      <div class="mat-display-1">Display 1</div>
      <h1>H1 Header</h1>
      <h2>H2 Header</h2>
      <h3>H3 Header</h3><p>text</p>
      <h4>H4 Header</h4><p>text</p>
      <p><span class="run-in">run-in</span> text</p>
      <h6>H6</h6><p>text</p>


      <div class="mat-headline">Headline</div>
      <div class="mat-title">Title</div>
      <div class="mat-subheading-2">Subheading 2</div>text
      <div class="mat-subheading-1">Subheading 1</div>text
      <div class="mat-h5">H5</div>
      <div class="mat-h6">H6</div>

      <div class="mat-body">Body</div>
      <div class="mat-body-strong">Body Strong</div>
      <b>Bold</b>
      <div class="mat-caption">Caption</div> -->
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>Map</mat-card-title>
  </mat-card>
</div>

